export function getTrackerToken() {
    return process.env.REACT_APP_API_KEY;
}